

/* ------------------------------------------------------------------------- */
/*  Load high res backgrounds
/* ------------------------------------------------------------------------- */

const init = function(bgElements) {
  for (var i = 0; i < bgElements.length; i++) {
    const highResBg = bgElements[i].getAttribute('data-highres-bg');
    if (highResBg) {
      bgElements[i].style.backgroundImage = 'url('+highResBg+')';
    }
  }
}

export default {
  init: init
}
